import { render, staticRenderFns } from "./RegularCard.vue?vue&type=template&id=ba0c1738&scoped=true&"
import script from "./RegularCard.vue?vue&type=script&lang=js&"
export * from "./RegularCard.vue?vue&type=script&lang=js&"
import style0 from "./RegularCard.vue?vue&type=style&index=0&id=ba0c1738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0c1738",
  null
  
)

export default component.exports